var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3644 2.99996L19.3642 2.99986L19.3643 4.99986L12.3644 4.99996L12.3643 15.1718L16.314 11.2221L17.7282 12.6363L11.3643 19.0002L5.00026 12.6363L6.41446 11.2221L10.3643 15.1718L10.3644 2.99996Z",
    fill: "#FF0055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemPoint);
export default __webpack_public_path__ + "static/media/RedeemPoint.1a32e17047ad4768a615c06de2f91a5f.svg";
export { ForwardRef as ReactComponent };